module.exports = __webpack_public_path__ + "static/media/9.7ff7bd94.png";